module.exports = __webpack_public_path__ + "img/university-df1.07ddaf68.png";